// extracted by mini-css-extract-plugin
module.exports = {"group":"form_group_group__20Qal","title":"form_group_title__MmmNU","content":"form_group_content__33ebt"};